const operationTypeMap: { [key: string]: string } = {
    'read': 'rest-operation',
    'vread': 'rest-operation',
    'update': 'rest-operation',
    'delete': 'rest-operation',
    'create': 'rest-operation',
    'search': 'rest-operation',
    'history': 'rest-operation',
    'capabilities': 'rest-operation',
    'transaction': 'rest-operation',
    'patch': 'rest-operation',
    'custom-operation': 'rest-operation',
};

export default operationTypeMap;